export default {
  checkout: {
    details: {
      borderRadius: '8px',
      boxShadow:
        '0px 4px 32px rgba(101, 106, 120, 0.04), 0px 4px 28px rgba(101, 106, 120, 0.04), 0px 4px 20px rgba(101, 106, 120, 0.04), 0px 4px 16px rgba(101, 106, 120, 0.04)',
      bg: 'white',
      padding: '1.5rem',
      my: 20
    }
  },
  product: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    borderRadius: 8,
    boxShadow: 'cards.medium',
    bg: 'white',
    padding: 20
  },
  medium: {
    bg: 'white',
    boxShadow: 'cards.large',
    borderRadius: 'cards.medium',
    padding: 25
  }
};
